import { useEffect, useState } from 'react';

/** Monotonically increasing counter that ticks at `fps`. Pass `0` to pause. */
export function useRowTick(fps: number): number {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (fps <= 0) return;
    const id = window.setInterval(() => setTick((t) => t + 1), 1000 / fps);
    return () => window.clearInterval(id);
  }, [fps]);
  return tick;
}
